var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mb-12", attrs: { tile: "" } },
    [
      _c("v-card-title", [
        _vm._v(" Details Tech Area " + _vm._s(_vm.Model.Name) + " "),
      ]),
      _c("v-divider"),
      _c(
        "v-form",
        [
          _c(
            "v-container",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "2" } },
                    [
                      _c("pga-text-field", {
                        attrs: { label: "Code", readonly: "" },
                        model: {
                          value: _vm.Model.Code,
                          callback: function ($$v) {
                            _vm.$set(_vm.Model, "Code", $$v)
                          },
                          expression: "Model.Code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("pga-text-field", {
                        attrs: { label: "Title", readonly: "" },
                        model: {
                          value: _vm.Model.Name,
                          callback: function ($$v) {
                            _vm.$set(_vm.Model, "Name", $$v)
                          },
                          expression: "Model.Name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("pga-text-field", {
                        attrs: { label: "Business Line", readonly: "" },
                        model: {
                          value: _vm.Model.BusinessLine.Title,
                          callback: function ($$v) {
                            _vm.$set(_vm.Model.BusinessLine, "Title", $$v)
                          },
                          expression: "Model.BusinessLine.Title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("pga-text-field", {
                        attrs: { label: "Cost Center", readonly: "" },
                        model: {
                          value: _vm.Model.AreaManager.CostCenter,
                          callback: function ($$v) {
                            _vm.$set(_vm.Model.AreaManager, "CostCenter", $$v)
                          },
                          expression: "Model.AreaManager.CostCenter",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "2" } },
                    [
                      _c("pga-entity-status", {
                        attrs: { title: "Status" },
                        model: {
                          value: _vm.Model.Status,
                          callback: function ($$v) {
                            _vm.$set(_vm.Model, "Status", $$v)
                          },
                          expression: "Model.Status",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }